import React from 'react';

import { useMask } from '@react-input/mask';
import { useNumberFormat, format } from '@react-input/number-format';

const masks = {
  phone: {
    mask: '(___) ___-____',
    replacement: { _: /\d/ },
    showMask: true,
  },
  ein: {
    mask: '__-_______',
    replacement: { _: /\d/ },
    showMask: true,
  },
  ssn: {
    mask: '___-__-____',
    replacement: { _: /\d/ },
    showMask: true,
  },
  number: {
    mask: '##############',
    replacement: { '#': /\d/ },
    showMask: false,
  },
};

const currencySettings = {
  locales: 'en',
  maximumFractionDigits: 2,
  format: 'currency',
  currency: 'USD',
};

const formatInitialCurrencyValue = (value) => {
  if (!value) {
    return '';
  }

  if (!value.toString()?.includes?.('$')) {
    return format(value, currencySettings);
  } else {
    return value;
  }
};

export default function TextInput({
  label,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  errors,
  touched,
  type,
}) {
  const withMask = !!masks[type];

  const inputRef = useMask(masks[type] || {});
  const currencyInputRef = useNumberFormat(currencySettings);

  let currentInputRef = null;

  if (withMask) {
    currentInputRef = inputRef;
  }
  if (type === 'currency') {
    currentInputRef = currencyInputRef;
  }

  let currentType = 'text';
  if (type === 'password') {
    currentType = 'password';
  }

  return (
    <div className="w-full">
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      <input
        ref={currentInputRef}
        value={type === 'currency' ? formatInitialCurrencyValue(value) : value}
        onChange={onChange}
        onBlur={onBlur}
        type={currentType}
        name={name}
        id={name}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        placeholder={placeholder}
        disabled={disabled}
      />
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
